<!--
 * @Description: 银行信息
 * @Date: 2025-05-20 18:01:30
-->

<template>
  <div class="account-info__items">
    <BaseTextTitle class="account-info__items__title">银行信息</BaseTextTitle>
    <BaseTextContent class="account-info__content">
      <BaseFormItem
        label="开户银行"
        prop="openBankNode"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请选择'
          }
        ]"
      >
        <BaseSelect
          placeholder="请选择"
          label-key="bankName"
          value-key="bankCode"
          init
          clearable
          filterUseRemote
          v-model="formData.openBankNode"
          :remoteMethod="bankRemote"
          :remoteSelected="[
            {
              bankCode: formData.openBankNode,
              bankName: formData.openBankName
            }
          ]"
          @change="onBankChange"
        ></BaseSelect>
      </BaseFormItem>
      <BaseFormItem
        label="开户名"
        prop="openName"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]"
      >
        <BaseInput
          style="width: 100%"
          type="text"
          placeholder="请输入"
          v-model="formData.openName"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem
        label="银行账号"
        prop="openBankNumber"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]"
      >
        <BaseInput
          style="width: 100%"
          type="text"
          placeholder="请输入"
          clearable
          v-model="formData.openBankNumber"
        ></BaseInput>
      </BaseFormItem>
    </BaseTextContent>
  </div>
</template>

<script lang="ts" setup>
import {
  BaseFormItem,
  BaseInput,
  BaseSelect,
  BaseTextContent,
  BaseTextTitle
} from 'xrk-components';
import { storeToRefs } from 'pinia';
import infoStore from '../../store/info';
import { bankList } from '../../data-source/apis';

const { formData, payPassagewayCode } = storeToRefs(infoStore());

const bankRemote = async name => {
  const resp = await bankList({
    name,
    payPassagewayCode: payPassagewayCode.value
  });
  return resp;
};

const onBankChange = (val, [option]) => {
  formData.value.openBankName = option ? option.bankName : null;
};
</script>
